<template>
  <div class="mx-auto container container--fluid">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-app id="inspire" class="">
      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Application Form Fees</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <template v-if="load == true">
          <v-data-table
            :headers="headers"
            dense
            :items="application_form_fee_master_list"
            class="elevation-1 mytable"
            :search="search"
          >
            <template v-slot:top>
              <v-toolbar dense flat color="white">
                <!-- <v-toolbar-title>Application Form Fees Master</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider> -->
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                >
                </v-text-field>
                <span style="width: 20px"></span>
                <v-dialog v-model="dialog" max-width="500px">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="button"
                      v-on="on"
                      @click="iseditable = !iseditable"
                      >New Application Form Fees</v-btn
                    >
                  </template>
                  <v-card>
                    <v-form v-model="valid">
                      <v-card-title class="toolbar">
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12">
                              <v-select
                                dense
                                v-model="editedItem.admissionYear"
                                :items="academicYearList"
                                :readonly="editedIndex == -1 ? false : true"
                                item-text="academicyear"
                                item-value="id"
                                label="Admission Year"
                                persistent-hint
                                :disabled="editedIndex != -1"
                                :hint="
                                  iseditable ? 'Academic Year' : 'noneditable'
                                "
                                :filled="editedIndex == -1 ? false : true"
                                :rules="[(v) => !!v || 'required']"
                                return-object
                                single-line
                              ></v-select>
                            </v-col>
                          </v-row>
                           <v-row>
                            <v-col cols="12">
                              <v-select
                                dense
                                v-model="editedItem.standard"
                                :items="standard_list"
                                :readonly="editedIndex == -1 ? false : true"
                                item-text="standard"
                                item-value="standard"
                                label="Standard"
                                persistent-hint
                                multiple
                                chips
                                :disabled="editedIndex != -1"
                                :hint="
                                  iseditable ? 'Standard' : 'noneditable'
                                "
                                :filled="editedIndex == -1 ? false : true"
                              ></v-select>
                            </v-col>
                          </v-row>
                          <v-row dense>
                            <v-col cols="12">
                              <v-text-field
                                :rules="[(v) => !!v || 'required']"
                                v-model="editedItem.amount"
                                label="Amount"
                                dense
                                hint="500, 1800"
                              ></v-text-field>
                            </v-col>

                            <v-col cols="12">
                              <v-text-field
                                v-model="editedItem.prefixvalue"
                                label="Prefix"
                                persistent-hint
                                :disabled="editedIndex != -1"
                                :hint="iseditable ? 'A, B' : 'noneditable'"
                                :filled="editedIndex == -1 ? false : true"
                                v-on:input="prevalue = $event.target.value"
                              ></v-text-field>
                              <!-- <p>prefix: {{ editedItem.prefixvalue }}</p> -->
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                type="number"
                                :rules="[(v) => !!v || 'required']"
                                v-model="editedItem.receiptTrackingNumber"
                                label="Tracking Number"
                                dense
                                persistent-hint
                                :disabled="editedIndex != -1"
                                :hint="iseditable ? '101,488' : 'noneditable'"
                                :filled="editedIndex == -1 ? false : true"
                              ></v-text-field>
                              <!-- <p>tracking: {{ editedItem.receiptTrackingNumber }}</p> -->
                            </v-col>

                            <v-col cols="12">
                              <label> Recipt No: </label
                              >{{ editedItem.prefixvalue
                              }}{{ editedItem.receiptTrackingNumber }}
                            </v-col>

                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                              v-if="editedIndex != -1"
                            >
                              <v-checkbox
                                dense
                                v-model="editedItem.isactive"
                                color="success"
                                label="Active"
                              ></v-checkbox>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="button" @click="close">Cancel</v-btn>
                        <v-btn class="button" @click="save">Save</v-btn>
                      </v-card-actions>
                    </v-form>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.isactive="{ item }">
              <span v-if="item.isactive">
                <v-icon small class="mr-2" color="success"
                  >mdi-check-circle-outline</v-icon
                >
              </span>
              <span v-else>
                <v-icon small class="mr-2" color="error"
                  >mdi-close-circle-outline</v-icon
                >
              </span>
            </template>
            <template v-slot:item.action="{ item }">
              <div>
                <v-avatar style="" size="25" class="edit-avatar">
                  <v-icon class="edit-v-icon mr-2" @click="editItem(item)"
                    >edit</v-icon
                  >
                </v-avatar>
              </div>
            </template>
          </v-data-table>
        </template>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    receiptTrackingNumber: "",
    prefixvalue: "",
    admissionYear: "",
    isactive: true,
    valid: false,
    overlay: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    iseditable: false,
    load: false,
    dialog: false,
    application_form_fee_master_list: null,
    academicYearList: null,
    search: "",
    headers: [
      { text: "Admission Year", value: "admissionYear" },
      { text: "Standard", value: "standard" },
      { text: "Amount", value: "amount" },
      { text: "Tracking No.", align: "center", value: "receiptTrackingNumber" },
      { text: "Prefix", value: "prefixvalue" },
      { text: "IsActive", value: "isactive" },
      { text: "Actions", value: "action", sortable: false },
    ],

    editedIndex: -1,
    editedItem: {
      AFFMid: 0,
      receiptTrackingNumber: "",
      prefixvalue: "",
      isactive: true,
      amount: "",
      admissionYear: "",
      standard:[]
    },
    defaultItem: {
      AFFMid: 0,
      receiptTrackingNumber: "",
      prefixvalue: "",
      isactive: true,
      amount: "",
      admissionYear: "",
      standard:[]
    },
    standard: null,
    standard_list:[]
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Application Form Fees Master"
        : "Edit Application Form Fees Master";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
  mounted() {
    axios
      .post("/admissionMaster/applicationFormFeeMaster")
      .then((res) => {
        if (res.data.msg == "200") {
          this.application_form_fee_master_list =
            res.data.application_form_fee_master_list;
          this.academicYearList = res.data.academicYearList;
          this.standard_list = [{ standard: "All" }, ...res.data.standard_list];
          
          this.load = true;
        } else {
        }
      })
      .catch((error) => {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        window.console.log(error);
      });
  },

  methods: {
    editItem(item) {
      this.iseditable = false;
      this.editedIndex = this.application_form_fee_master_list.indexOf(item);
      this.editedItem.standard = [item.standard];
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    // deleteItem(item) {
    //   const index = this.application_form_fee_master_list.indexOf(item);
    //   confirm("Are you sure you want to delete this item?") &&
    //     this.rolelist.splice(index, 1);
    // },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

  save() {
      if (this.editedIndex > -1) {
        this.iseditable = false;
        
        // Prepare payload for single item edit
        let editPayload = Object.assign({}, this.editedItem);
        if (Array.isArray(editPayload.standard)) {
           editPayload.standard = editPayload.standard[0]; // Convert back to string for edit API
        }

        axios
          .post("/admissionMaster/editApplicationFormFeeMaster", editPayload)
          .then((res) => {
            if (res.data.msg == "200") {
              Object.assign(
                this.application_form_fee_master_list[this.editedIndex],
                editPayload
              );
            }
            this.showSnackbar("#4caf50", "Application Form Fee Updated Successfully...");
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong..."); 
            window.console.log(error);
          });
      } else {
        if(this.editedItem.receiptTrackingNumber == '' || this.editedItem.receiptTrackingNumber == null) {
          this.showSnackbar("error","Please add receipt tracking number");
          return;
        }
        if(!this.editedItem.standard || this.editedItem.standard.length === 0) {
          this.showSnackbar("error", "Please select at least one standard");
          return;
        }
        if (this.editedItem.standard.includes("All")) {
          // Replaces "All" with an array of all actual standards
          this.editedItem.standard = this.standard_list
            .filter(item => item.standard !== "All")
            .map(item => item.standard);
        }

        axios
          .post("/admissionMaster/saveApplicationFormFeeMaster", this.editedItem)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              
              // NEW: Loop through selected standards to update frontend table
              this.editedItem.standard.forEach(singleStd => {
                let newRow = Object.assign({}, this.editedItem);
                newRow.standard = singleStd;
                this.application_form_fee_master_list.push(newRow);
              });
              
              this.showSnackbar("#4caf50", "Application Form Fee Added Successfully!!!"); 
            } else if (res.data.status.code == "NA") {
              this.showSnackbar("#b71c1c", "Application Form Fee Already Present!!!"); 
            } else {
              this.showSnackbar("#b71c1c", "Something went wrong");
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
      }
      this.close();
    },
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>
